<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="cadaverItems"
      :items-per-page="5"
      class="elevation-2"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 25, 50, -1]
      }"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="Search all"
          class="mx-4 py-2"
          filled
          hide-details
          clearable
        ></v-text-field>
      </template>
      <template v-slot:body.prepend="{ isMobile }">
        <tr v-if="!isMobile && !search">
          <td>
            <v-text-field
              class="my-2"
              v-model="PSearch"
              label="Search P"
              filled
              hide-details
              clearable
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              class="my-2"
              v-model="NameSearch"
              label="Search Name"
              filled
              hide-details
              clearable
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              class="my-2"
              v-model="RelativeSearch"
              label="Search Relative"
              filled
              hide-details
              clearable
            ></v-text-field>
          </td>
          <td colspan="1"></td>
        </tr>
      </template>
      <template v-slot:item.action="{ item }">
        <v-dialog scrollable>
          <template v-slot:activator="{ on }">
            <v-btn icon class="mx-1" v-on="on">
              <v-icon>
                {{ mdiFileEye }}
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline" primary-title>
              {{ item.number }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text--primary">
              <v-row>
                <v-col>
                  <p>
                    <v-btn
                      text
                      v-on:click="handleCadaverAsset(item.number, 'pictures')"
                      :disabled="loadingCadaverAsset"
                    >
                      Picture
                    </v-btn>
                  </p>
                  <p>
                    <v-btn
                      text
                      v-on:click="
                        handleCadaverAsset(item.number, 'condolences')
                      "
                      :disabled="loadingCadaverAsset"
                    >
                      คำไว้อาลัย
                    </v-btn>
                  </p>
                </v-col>
                <v-col cols="12" md="10">
                  <v-container tag="dl">
                    <v-row
                      v-for="item in parseCadaver(item.cadaver)"
                      :key="item.label"
                    >
                      <v-col tag="dt" class="font-weight-medium" cols="5">
                        {{ item.label }}
                      </v-col>
                      <v-col tag="dd" class="d-inline">
                        {{ item.value }}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
    <v-snackbar v-model="loadingCadaverAsset">
      ⏳ กำลังโหลด
    </v-snackbar>
    <v-snackbar v-model="cadaverAssetNotFound">
      ❌ ไม่พบ
    </v-snackbar>
  </v-container>
</template>

<script>
/// <reference path="../../types/cadavers.d.ts" />
import { mdiFileEye } from "@mdi/js";
import { apiFetch } from "../../api";

export default {
  name: "CadaverViewer",
  props: ["cadavers", "cadaverAssets"],
  data: () => ({
    search: "",
    PSearch: "",
    NameSearch: "",
    RelativeSearch: "",
    loadingCadaverAsset: false,
    cadaverAssetNotFound: false,
    mdiFileEye
  }),
  computed: {
    headers() {
      return [
        {
          text: "P",
          value: "number",
          filter: (value, search, item) => {
            if (search) {
              return JSON.stringify(item.cadaver).includes(search);
            }
            if (!this.PSearch) return true;
            return value.includes(this.PSearch);
          }
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
          filter: value => {
            if (!this.NameSearch || this.search) return true;
            return value.includes(this.NameSearch);
          }
        },
        {
          text: "Relative",
          value: "relative",
          sortable: false,
          filter: value => {
            if (!this.RelativeSearch || this.search) return true;
            return value.includes(this.RelativeSearch);
          }
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          sortable: false,
          filterable: false
        }
      ];
    },
    cadaverItems() {
      return Object.keys(this.cadavers).map(No => {
        /** @type Cadaver */
        const cadaver = this.cadavers[No];
        return {
          number: No,
          name: cadaver.title + cadaver.name + " " + cadaver.surname,
          relative: `${cadaver.relative.title}${cadaver.relative.name} ${cadaver.relative.surname} (${cadaver.relative.type})`,
          cadaver: cadaver
        };
      });
    }
  },
  methods: {
    handleCadaverAsset(number, type) {
      this.cadaverAssetNotFound = false;
      this.loadingCadaverAsset = true;
      apiFetch("/admin", {
        body: {
          cadaverAsset: {
            number,
            type
          }
        }
      })
        .then(res => res.json())
        .then(json => {
          this.loadingCadaverAsset = false;
          if (json.cadaverAsset && json.cadaverAsset[type]) {
            window.open(json.cadaverAsset[type].download_url);
          } else {
            this.cadaverAssetNotFound = true;
          }
        });
    },
    parseCadaver(cadaver) {
      function flattenObject(object) {
        const result = {};
        Object.keys(object).forEach(key => {
          const value = object[key];
          if (value === null) {
            result[key] = "(ไม่มีข้อมูล)";
          } else if (Array.isArray(value)) {
            result[key] = value
              .map(item => flattenObject(item))
              .map(item => Object.values(item).join(" "))
              .join("\n");
          } else if (typeof value === "object") {
            const flattened = flattenObject(value);
            Object.keys(flattened).forEach(flattenedKey => {
              result[`${key}.${flattenedKey}`] = flattened[flattenedKey];
            });
          } else {
            result[key] = value;
          }
        });
        return result;
      }
      const flattened = flattenObject(cadaver);
      return Object.keys(flattened).map(key => ({
        label: key,
        value: String(flattened[key])
      }));
    }
  }
};
</script>
